'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _envInfo = require('../constants/envInfo');

var _envInfo2 = _interopRequireDefault(_envInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function appOrigin() {
  return window.location.origin.replace('local', 'app');
}

//this is so that during local testing, last redirect is to app, and doesn't let test fail locally
var hostname = _envInfo2.default.isLocal ? appOrigin() : '' + window.location.hostname;

var origin = window.location.protocol + '//' + hostname;
exports.default = origin;
module.exports = exports['default'];